import {Injectable} from '@angular/core';

import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {Cart} from '@spartacus/cart/base/root';
import {CxEvent, EventService} from '@spartacus/core';
import {Observable, of, EMPTY} from 'rxjs';
import {map} from 'rxjs/operators';
import {DcpActiveCartService} from '../../dcp-active-cart.service';
import {DcpEddlCartStateService} from './dcp-eddl-cart-state.service';
import {AbstractEddlCartService} from './abstract-eddl-cart.service';
import {EddlRemoveFromCartEvent} from './events/eddl-remove-from-cart-event';
import {EddlAdobeTrackingData} from './models/eddl-adobe-tracking-data';

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class DcpEddlRemoveFromCartService extends AbstractEddlCartService<EddlRemoveFromCartEvent> {
  constructor(
    protected eventService: EventService,
    protected eddlCartStateService: DcpEddlCartStateService,
    protected activeCartService: DcpActiveCartService
  ) {
    super(eventService, eddlCartStateService, activeCartService);
  }

  protected getEventName(): string {
    return 'cartRemove';
  }

  getData(event: CxEvent): Observable<EddlAdobeTrackingData> {
    if (!(event instanceof EddlRemoveFromCartEvent)) {
      return EMPTY;
    }

    // If cart was captured before removal and present in event, use it directly
    if (event.cart) {
      const allEntries = this.collectEntriesForEvent(event, event.cart);
      return of(this.fillData(event, allEntries, event.cart));
    }

    // Fallback to fetching current cart
    return this.activeCartService.getActiveCart().pipe(
      untilDestroyed(this),
      map((cart: Cart) => {
        event.cart = cart;
        const allEntries = this.collectEntriesForEvent(event, cart);
        return this.fillData(event, allEntries, cart);
      })
    );
  }
}
